import React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";

import { Contract } from "@ethersproject/contracts";
import { Wallet } from "@ethersproject/wallet";
import { JsonRpcProvider } from "@ethersproject/providers";
import { keccak256 } from "@ethersproject/keccak256";
import { toUtf8Bytes } from "@ethersproject/strings";
import { isAddress } from "@ethersproject/address";
import { ethers } from "ethers";

import Select from "./Select";
import Modal from "./UI/Modal";

import { FAUCET_ABI, ERC20_ABI, CONFIG } from "../constants";
// import { FAUCETTOKEN_ABI } from "../constants";
// import { CONFIG } from "../constants";
import { PK } from "../constants";

const availableNetworks = Object.keys(CONFIG).filter((key) => {
  return CONFIG[key].contracts.Factory !== "";
});
//console.log(availableNetworks);

const networkError = "Network error...";

let tokenAddress;

const Label = styled.label`
  margin-bottom: 0.5em;
  color: black;
  display: block;
`;

const SButton = styled.button`
  padding: 0.5em;
  color: black;
  border: none;
  width: 30%;
  margin: 0.5em;
  font-weight: 500;
  background-color: rgb(84, 102, 253);
  color: rgb(255, 255, 255);
  border-radius: 12px;
`;

const SInput = styled.input`
  padding: 0.5em;
  color: black;
  border: solid;
  width: 80%;
  margin-bottom: 0.5em;
  border-radius: 12px;
`;

const FaucetForm = () => {
  const [userInputAddress, setUserInputAddress] = useState("");
  const [userInputNetwork, setUserInputNetwork] = useState(
    availableNetworks[0]
  );
  const [userInputToken, setUserInputToken] = useState("Loading...");
  const [availableTokens, setAvailableTokens] = useState([]);

  const [modalState, setModalState] = useState(false);
  const [isError, setIsError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const configWallet = () => {
    const provider = new JsonRpcProvider(
      CONFIG[userInputNetwork].network.rpc_url
    );
    const wallet = new Wallet(
      PK, //need to use process.env.pk
      provider
    );
    return wallet;
  };

  const wallet = configWallet();
  const factoryAddress = CONFIG[userInputNetwork].contracts.Factory;
  const albtAddress = CONFIG[userInputNetwork].contracts.Albt;
  

  const faucetContractCheck = () => {
    if (factoryAddress) {
      return new Contract(factoryAddress, FAUCET_ABI, wallet);
    } else {
      return undefined;
    }
  };

  const albtContractCheck = () => {
    if (albtAddress) {
      return new ethers.Contract(albtAddress, ERC20_ABI, wallet);
    } else {
      return undefined;
    }
  };

  const faucetContract = faucetContractCheck();
  const albtContract = albtContractCheck();

  const getTokensSymbols = async () => {
    setIsLoading(true);
    let tokens = [];
    if (factoryAddress) {
      tokens = await faucetContract.allTokens();
      setAvailableTokens(tokens);
    } else {
      setAvailableTokens([]);
    }

    if (tokens[0]) {
      setUserInputToken(tokens[0]);
    } else {
      setUserInputToken([networkError]);
      inputTokenHandler(networkError);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTokensSymbols();
    //console.log("userInputToken", userInputToken);
  }, [userInputNetwork, setIsLoading]);

  const inputAddressHandler = (event) => {
    setUserInputAddress(event.target.value);
  };

  const inputNetworkHandler = (data) => {
    setUserInputToken("Loading...");
    setAvailableTokens(["Loading..."]);
    setUserInputNetwork(data);
  };

  const inputTokenHandler = (data) => {
    setUserInputToken(data);
  };


  const sendTokensHandler = async () => {
    if (userInputToken === networkError || userInputToken === "Loding...") {
      alert("Network Error");
      return;
    }

    if (!isAddress(userInputAddress)) {
      setIsError("Address is not valid");
      return;
    }

    setUserInputAddress("Sending...");
    setIsLoading(true);
    sendTx().catch((error) => {
      //alert("");
      //console.log(error)
      setUserInputAddress("Please spend your tokens first!");
      setIsLoading(false);
    });
  };

  const sendTx = async () => {
    const tokenId = keccak256(toUtf8Bytes(userInputToken));
    const address = await faucetContract.tokenAddress(tokenId);

    if (address === "0x0000000000000000000000000000000000000000") {
      alert("Token does not exist");
      return;
    }
    tokenAddress = address;

    if (userInputToken === "wALBT") {
      //send albt from wallet
      
      const tx = await albtContract.transfer(
        userInputAddress,
        ethers.utils.parseEther("5.0")
      );
      const txReceipt = await tx;

      tokenAddress = albtContract.address

      if (txReceipt.status !== 1) {
        onToggleModalHandler();
      }
    } else {
      const tx = await faucetContract.faucet(tokenId, userInputAddress);
      const txReceipt = await tx;
      if (txReceipt.status !== 1) {
        onToggleModalHandler();
        setUserInputAddress(userInputAddress);
        setIsLoading(false);
        return
      }
    }

    //console.log("txReceipt.hash", txReceipt.hash);
    setUserInputAddress("");
    setIsLoading(false);
  };

  const onToggleModalHandler = () => {
    setModalState((state) => !state);
  };

  return (
    <>
      {modalState && (
        <Modal>
          <h3>Transaction successful</h3>
          <br />
          <p>You can add this token to metamask</p>
          <p>Token: {userInputToken} </p>
          <p>Address: {tokenAddress} </p>
          <p>Network: {userInputNetwork}</p>
          <div className="button-div">
            <SButton onClick={onToggleModalHandler}>Done</SButton>
          </div>
        </Modal>
      )}
      <div className="input-group">
        <Select
          id="network-select"
          value={userInputNetwork}
          label="Network"
          onChange={inputNetworkHandler}
          options={availableNetworks}
        />
      </div>

      <div className="input-group">
        <Select
          id="token-select"
          value={userInputToken}
          label="Token"
          onChange={inputTokenHandler}
          options={availableTokens}
        />
      </div>

      <div className="input-group">
        <Label htmlFor="user-address">
          Testnet account address:{" "}
          {isError && <span className="error">{isError}</span>}
        </Label>
        <SInput
          className="form-control"
          id="user-address"
          name="user-address"
          placeholder="Ex: 0x7D48BeD41C6778191950BEFb4359FEC07fCB9aAE"
          value={userInputAddress}
          onChange={inputAddressHandler}
        ></SInput>
      </div>

      {!isLoading ? (
        <SButton onClick={sendTokensHandler}>Send request</SButton>
      ) : (
        <SButton disabled style={{ backgroundColor: "gray" }}>
          Fetching data
        </SButton>
      )}
    </>
  );
};

export default FaucetForm;
